export default __webpack_public_path__ + "static/media/fondoPadel4.ca745a34.jpg";